/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Pipe, PipeTransform } from '@angular/core';
import { XdaStringsService } from '../services/xda-strings.service';

@Pipe({
  name: 'orderBy',
  pure: false,
  standalone: false,
})
export class OrderBy<T> implements PipeTransform {
  constructor(private xdaStringsService: XdaStringsService) {}

  transform(data: T[], order: string, property: string) {
    if (property) {
      data = data.sort((a, b) => {
        const recordA = a as Record<string, unknown>;
        const recordB = b as Record<string, unknown>;
        const keyA = String(recordA[property] ?? '');
        const keyB = String(recordB[property] ?? '');
        const val1 = this.xdaStringsService.strings[keyA] || keyA;
        const val2 = this.xdaStringsService.strings[keyB] || keyB;
        const res = String(val1).localeCompare(String(val2));
        return order === 'asc' ? res : -res;
      });
    }
    return data;
  }
}
